import { timer } from "rxjs";

import { requestKMKSellerId } from "../utils/parentWindowConnection";

export const trackKmkSellerId = () => {
    return timer(1000, 1000 * 5).subscribe(() => {
        requestKMKSellerId();
    });
};



// WEBPACK FOOTER //
// ./src/jobs/trackKmkSellerId.js